import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchGradeById (_, { gradeId }) {
    const response = await ApiServer.get('grades', gradeId)
    return response.data
  },

  async fetchGrades (context) {
    context.commit('setGradesLoading', true)
    const response = await ApiServer.get('grades')
    const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name))
    context.commit('setGrades', sortedData)
    context.commit('setGradesLoading', false)
    return sortedData
  },

  async deleteGrade (context, gradeId) {
    const response = await ApiServer.delete(`grades/${gradeId}`)
    context.commit('removeGrade', gradeId)
    return response.data
  },

  async createGrade (context, grade) {
    const response = await ApiServer.post('grades', grade)
    context.commit('addGrade', response.data)
    return response.data
  },

  async updateGrade (context, grade) {
    const response = await ApiServer.put(`grades/${grade.gradeId}`, grade)
    context.commit('updateHarvestType', response.data)
    return response.data
  }
}
